import { useState, useEffect, useMemo } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Breadcrumb, Button, DataTable, Skeleton, UserHelp } from "@imedcl/design-system";
import './style.scss';
import { encode } from 'string-encode-decode'
import moment from 'moment';
import { ReactComponent as ImagenMujer } from "../../assets/img/carga_nuevos_datos.svg"
import { ModalMFA } from "../ModalMFA/ModalMFA";
import { ModalErrorEmailNotFound } from '../ModalErrorEmailNotFound/ModalErrorEmailNotFound'

export default function ListDebts() {
  const navigate = useNavigate();
  const location = useLocation();
  const { documentos, cantidad, selectedRows } = location.state || { documentos: [], cantidad: 0, selectedRows: [] };
  const [error, setError] = useState("");
  const [name, setName] = useState("");
  const [divDisable, setDivDisable] = useState(false);
  var arrayTable = useMemo(() => [], []);
  var folios = useMemo(() => [], []);
  const [nfolio, setnFolio] = useState([]);
  const [rutCliente, setRut] = useState(0);
  const [total, setTotal] = useState("Total a pagar $0");
  const [checked, setChecked] = useState([]);
  var [arrList, setArrayList] = useState(() => [], []);
  const [checkAllActive, setCheckAllActive] = useState(false);
  const [selected, setSelected] = useState(null);
  const [mfaVerifiedAt, setMfaVerifiedAt] = useState(null);

  //Esta es la funcion que hace la carga del datable.
  useEffect(() => {
    (async () => {
      //Al obtener la session activa preguntamos si ya fue iniciada anteriormente y seguimos contando los segundos para cerrar la sessión, si no lo llevamos al login.
      let sessionActive = localStorage.getItem("session")
      const storedMfa = localStorage.getItem("mfaVerifiedAt")
      if (storedMfa) {
        try {
          const parsedMfa = JSON.parse(storedMfa)
          setMfaVerifiedAt(parsedMfa.time)
        } catch {
          setMfaVerifiedAt(storedMfa)
        }
      }
      if (sessionActive) {
        window.setTimeout(function () {
          navigate("/expired/session")
        }, 900000)// tiempo en milisegundo.
      } else {
        navigate("/")
      }
      setDataTable();
      //Si entramos a este if es por que vienen elementos seleccionados.
      if (selectedRows.length > 0) {
        let total = 0;
        let modifiedData = [...checked];
        selectedRows.forEach(element => {
          modifiedData.forEach(item => {
            if (parseInt(element.id) === parseInt(item.index)) {
              if (!item.active) {
                item.active = true;
              }
            }
          });
          //Calculamos el total
          let num1 = element.monto.replace("$", '')
          let num2 = parseInt(num1.replaceAll(".", ''))
          total = parseInt(total + num2);
          folios.push({ folio: element.folio });
        });
        setTotal(`Total a pagar $${numberFormat(total)}`)
        setChecked(modifiedData);
        setDivDisable(true);
        setArrayList(selectedRows);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  //Esto nos indica que si la url cambia o el options cambia se va a volver a ejecutar automaticamente.

  const setDataTable = () => {
    try {
      if (arrayTable.length === 0) {
        //GUARDAMOS EN session STORAGE de la pagina los documentos.
        sessionStorage.setItem("documentos", encode(JSON.stringify(documentos)));
        const sortedArray = documentos.sort(function (a, b) { return new Date(a.FechaVcto) - new Date(b.FechaVcto) })
        sortedArray.forEach((element, index) => {
          if (element.xError)
            setError(element.xError);
          if (element.SaldoPorPagar > 0) {
            if (element.xError) {
              setError(element.xError);
            } else {
              setName(element.RazonSocial);
              setRut(element.Entidad)
              let data = {};
              data['index'] = index;
              data["fecha_emision"] = moment(element.Fecha).format("DD/MM/YYYY");
              data["folio"] = element.Folio;
              data["producto"] = element.TipoDocumento;
              data["fecha_vencimiento"] = moment(element.FechaVcto).format("DD/MM/YYYY");
              let vence = moment(element.FechaVcto);
              if (moment() <= moment(vence).endOf('day').valueOf()) {
                data["estado_vigencia"] = "Vigente";
              } else {
                data["estado_vigencia"] = "Vencida";
              }
              data["monto"] = `$${numberFormat(element.SaldoPorPagar)}`;
              data["Link_Factura"] = element.LinkFactura;
              data['email'] = element.eMail;
              arrayTable.push(data);
              let array = {};
              array['index'] = index;
              array['active'] = false;
              checked.push(array)
            }
          }
        });
      }
    } catch (error) {
      setError(error)
    }
  }

  const redirectLogin = () => {
    navigate("/")
  };

  const numberFormat = (value) => {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  const pay = () => {
    //Guardamos en el local storage los elementos seleccionados.
    localStorage.setItem("activeFunction", 1);
    sessionStorage.setItem("selectItems", encode(JSON.stringify(arrList)));
    const countFolios = nfolio.length;
    const json = { nDocumentos: countFolios, rut: rutCliente, documentos: nfolio };
    navigate("payDebts", { state: json });
  }

  const selectAllRecord = (e) => {
    setCheckAllActive(true)
    const modifiedData = [...checked];
    if (e.target.checked) {
      modifiedData.forEach((item) => {
        item.active = true;
      }
      );
      setDivDisable(false);
      setTotal("Total a pagar $0");
      folios = [];
      let total = 0;
      arrList = []
      arrayTable.forEach(value => {
        arrList.push({
          id: value.index,
          monto: value.monto,
          folio: value.folio
        })
        let num1 = value.monto.replace("$", '')
        let num2 = parseInt(num1.replaceAll(".", ''))
        total = parseInt(total + num2);
        const totalResult = `Total a pagar $${numberFormat(total)}`;
        setTotal(totalResult);
        folios.push({ folio: value.folio });
        setDivDisable(true);
      })
      setnFolio(folios);
      setArrayList(arrList);
    } else {
      modifiedData.forEach((item) => {
        item.active = false;
      }
      );
      setnFolio([]);
      setArrayList([]);
      setCheckAllActive(false)
      setDivDisable(false);
      setTotal("Total a pagar $0");
      folios = [];
    }
  }

  const handleChange = async (e) => {
    //Hace el checked del checkbox.
    const value = e.target.value;
    const modifiedData = [...checked];
    modifiedData.forEach((item) => {
      if (parseInt(item.index) === parseInt(value)) {
        if (!item.active) {
          item.active = true;
        } else {
          item.active = false;
        }
      }
    });
    setChecked(modifiedData);
    //fin.

    //parte de la funcion que calcula el total de las deudas.
    let val;
    let folio;
    arrayTable.forEach((item, index) => {
      if (parseInt(item.index) === parseInt(value)) {
        val = index
        folio = item.folio
      }
    })

    if (e.target.checked) {
      arrList.push({
        id: arrayTable[val].index,
        monto: arrayTable[val].monto,
        folio: arrayTable[val].folio
      })
    } else {
      let position;
      arrList.forEach((element, index) => {
        if (element.folio === folio) {
          position = index
        }
      });
      delete arrList[position]
    }
    setArrayList(arrList);

    const object = []
    arrList.forEach(element => {
      object.push(element);
    });

    if (parseInt(object.length) === 0) {
      setCheckAllActive(false)
      setDivDisable(false);
      setTotal("Total a pagar $0");
      setnFolio([])
    } else {
      folios = [];
      setDivDisable(true)
      let total = 0;
      object.forEach(value => {
        let num1 = value.monto.replace("$", '')
        let num2 = parseInt(num1.replaceAll(".", ''))
        total = parseInt(total + num2);
        const totalResult = `Total a pagar $${numberFormat(total)}`;
        setTotal(totalResult);
        folios.push({ folio: value.folio });
      })
      setnFolio(folios);
    }
  }

  return (
    <>
      {!error ? (
        <div className="flex m-5 mb-20 items-center justify-center">
          <div className="shadow-lg bg-white w-auto">
            <div className="m-5 ml-10 ">
              <Breadcrumb
                showBackButton={false}
                navOptions={[
                  {
                    label: 'Home',
                    url: '/',
                  },
                  {
                    label: 'Estado de facturas',
                  },
                ]}
                tooltipShow
                truncateLabel
              />
              <h2 className="m-4  text-2xl font-bold tracking-normal text-info-dark">
                Hola {name}
              </h2>
              <h1 className="m-4  text-neutral-60 font-medium leading-4 tracking-tight">
                Revisa y paga aquí tus facturas. Si lo deseas, puedes
                seleccionar más de una:
              </h1>
              <hr></hr>
              <div className="grid m-4 mt-8 justify-center">
                <DataTable
                  className="table-auto"
                  columns={[
                    {
                      Cell: ({ value, row }) => {
                        let val;
                        arrayTable.forEach((item, index) => {
                          if (parseInt(item.index) === parseInt(value)) {
                            val = index
                          }
                        })
                        return (
                          <input
                            type="checkbox"
                            name="Status"
                            value={value}
                            checked={checked[val].active}
                            onChange={handleChange}
                          />
                        );
                      },
                      Header: () => (
                        <input
                          type="checkbox"
                          name="Status"
                          value="value"
                          checked={checkAllActive}
                          onChange={selectAllRecord}
                        />
                      ),
                      accessor: 'index',
                      filter: 'exact',
                      skeleton: <Skeleton customClass="w-[50%] h-4 pl-4 m-auto mt-1 mb-1" />,
                      sortDescFirst: false
                    },
                    {
                      Header: () => (
                        <span className="text-neutral-80 tracking-normal font-medium w-32">
                          Fecha Emision
                        </span>
                      ),
                      accessor: "fecha_emision",
                      HeaderWidth: "w-[20%]",
                      skeleton: <Skeleton customClass="w-[70%] h-4 pl-4 m-auto mt-1 mb-1" />,
                      Cell: ({ value, row }) => {
                        return (
                          <span className="text-neutral-80 tracking-normal font-light">
                            {value}
                          </span>
                        );
                      },
                      filter: "exact",
                      sortDescFirst: false,
                    },
                    {
                      Header: () => (
                        <span className="text-neutral-80 tracking-normal font-medium">Folio</span>
                      ),
                      accessor: "folio",
                      HeaderWidth: "w-[20%]",
                      skeleton: <Skeleton customClass="w-[70%] h-4 pl-4 m-auto mt-1 mb-1" />,
                      Cell: ({ value, row }) => {
                        return (
                          <span className="text-neutral-80 tracking-normal font-light">
                            {value}
                          </span>
                        );
                      },
                      filter: "exact",
                      sortDescFirst: false,
                    },
                    {
                      Header: () => (
                        <span className="text-neutral-80 tracking-normal font-medium">
                          Producto
                        </span>
                      ),
                      accessor: "producto",
                      HeaderWidth: "w-[20%]",
                      skeleton: <Skeleton customClass="w-[70%] h-4 pl-4 m-auto mt-1 mb-1" />,
                      Cell: ({ value, row }) => {
                        return (
                          <span className="text-neutral-80 tracking-normal font-light ml-10">
                            {value}
                          </span>
                        );
                      },
                      filter: "exact",
                      sortDescFirst: false,
                    },
                    {
                      Header: () => (
                        <span className="text-neutral-80 tracking-normal font-medium w-40">
                          Fecha Vencimiento
                        </span>
                      ),
                      accessor: "fecha_vencimiento",
                      HeaderWidth: "w-[20%]",
                      skeleton: <Skeleton customClass="w-[70%] h-4 pl-4 m-auto mt-1 mb-1" />,
                      Cell: ({ value, row }) => {
                        return (
                          <span className="text-neutral-80 tracking-normal font-light">
                            {value}
                          </span>
                        );
                      },
                      filter: "exact",
                      sortDescFirst: false,
                    },
                    {
                      Header: () => (
                        <span className="text-neutral-80 tracking-normal font-medium w-32">Monto a Pagar</span>
                      ),
                      accessor: "monto",
                      HeaderWidth: "w-[20%]",
                      skeleton: <Skeleton customClass="w-[70%] h-4 pl-4 m-auto mt-1 mb-1" />,
                      Cell: ({ value, row }) => {
                        return (
                          <span className="text-neutral-80 tracking-normal font-light">
                            {value}
                          </span>
                        );
                      },
                      filter: "exact",
                      sortDescFirst: false,
                    },
                    {
                      Header: () => (
                        <span className="text-neutral-80 tracking-normal font-medium w-32">
                          Estado Vigencia
                        </span>
                      ),
                      accessor: "estado_vigencia",
                      HeaderWidth: "w-[20%]",
                      skeleton: <Skeleton customClass="w-[70%] h-4 pl-4 m-auto mt-1 mb-1" />,
                      Cell: ({ value, row }) => {
                        if (value === "Vigente") {
                          return (
                            <span className="text-green-500">
                              {value}
                            </span>
                          );
                        } else {
                          return (
                            <span className="text-yellow-400">
                              {value}
                            </span>
                          );
                        }
                      },
                      filter: "exact",
                      sortDescFirst: false,
                    },
                    {
                      Header: () => (
                        <span className="text-neutral-80 tracking-normal font-medium w-32"></span>
                      ),
                      accessor: "Link_Factura",
                      HeaderWidth: "w-[20%]",
                      skeleton: <Skeleton customClass="w-[70%] h-4 pl-4 m-auto mt-1 mb-1" />,
                      Cell: ({ value, row }) => {
                        const now = new Date();
                        const mfaDate = new Date(mfaVerifiedAt);
                        const isFromPreviousDay = mfaDate.toDateString() !== now.toDateString();

                        const openModal = () => {
                          const stored = localStorage.getItem('mfaVerifiedAt')
                          let rutMismatch = false
                          if (stored) {
                            try {
                              const parsed = JSON.parse(stored)
                              const storedRut = atob(parsed.rut)
                              if (String(storedRut) !== String(rutCliente)) {
                                rutMismatch = true
                              }
                            } catch {
                              // formato antiguo, ignorar
                            }
                          }
                          if (!mfaVerifiedAt || isFromPreviousDay || rutMismatch) {
                            setSelected(row.original)
                            localStorage.removeItem('mfaVerifiedAt');
                            if (rutMismatch) setMfaVerifiedAt(null)
                          } else {
                            window.open(value, "_blank", "noopener,noreferrer")
                          }
                        }

                        return (
                          <span className="text-neutral-80 tracking-normal font-light">
                            <button onClick={openModal} className="underline text-blue-600 hover:text-rose-900">
                              Ver Factura
                            </button>
                          </span>
                        );
                      },
                      filter: "exact",
                      id: "expander",
                      sortDescFirst: false,
                    },
                  ]}
                  data={arrayTable}
                  fetchData={function noRefCheck() { }}
                  hideFilter
                  hidePagination
                  orderBy="folio"
                  renderRowSubComponent={function noRefCheck() { }}
                  statusName="folio"
                  tableFilterStatus={function noRefCheck() { }}
                  totalResults={cantidad}
                />
                {divDisable ? (
                  <div className="mt-0 m-5" id="info-pago">
                    <UserHelp
                      button={<Button className="mt-0 text-center" size="m" type="primary" onClick={pay}>Continuar</Button>}
                      customTitleClass="font-bold mb-1 p-0 text-lg"
                      title={total}
                    />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          {selected ? (
            selected.email ? (
              <ModalMFA isOpen={!!selected} onClose={() => setSelected(null)} billing={selected} rut={rutCliente} setMfaVerifiedAt={setMfaVerifiedAt} />
            ) : (
              <ModalErrorEmailNotFound onClose={() => setSelected(null)} />
            )
          ) : null}
        </div>
      ) : (
        <div className="flex items-center justify-center">
          <div className="shadow-lg bg-white w-9/12 ">
            <div className="grid m-20 justify-center">
              <div className="flex items-center justify-center">
                <ImagenMujer size="xl" customWidth="320"></ImagenMujer>
              </div>
              <h1 className="m-2 text-neutral-60 font-medium leading-4 tracking-tight">
                {error}
              </h1>
              <Button
                className="m-3 text-center"
                size="m"
                type="secondary"
                onClick={redirectLogin}
              >
                Volver
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
